module.exports = require("core-js/library/fn/object/entries");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/entries.js
// module id = 1450
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16